import { render, staticRenderFns } from "./noSpeak.vue?vue&type=template&id=7349b708&scoped=true"
import script from "./noSpeak.vue?vue&type=script&lang=js"
export * from "./noSpeak.vue?vue&type=script&lang=js"
import style0 from "./noSpeak.vue?vue&type=style&index=0&id=7349b708&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349b708",
  null
  
)

export default component.exports